import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import fr from 'vuetify/es5/locale/fr';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            light: {
                primary: '#ff1400',
                secondary: '#848587',
                accent: '#e83f41',
                error: '#f33333',
                info: '#00bcd4',
                success: '#8bc34a',
                warning: '#ef562d'
            },
        },
    },
    lang: {
        locales: { fr },
        current: 'fr',
    },
});
